import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";

import { getResultsTableData } from "util/getDivisionResultsData";
import { getBenchLabel } from "util/meetHelper";
import Table from "components/table/Table";
import NameCell from "./cells/NameCell";
import PlaceCell from "./cells/PlaceCell";
import AttemptCell from "./cells/AttemptCell";
import TotalCell from "./cells/TotalCell";
import BodyWeightAdjustedTotalCell from "./cells/BodyWeightAdjustedTotalCell";
import AgeAdjustedTotalCell from "./cells/AgeAdjustedTotalCell";
import BodyWeightAndAgeAdjustedTotalCell from "./cells/BodyWeightAndAgeAdjustedTotalCell";

class TeamResultsTable extends Component {
  getAllColumns = () => {
    // prettier-ignore
    return [
      {key: 'name', label: 'Name', width: 220, renderer: NameCell},
      {key: 'place', label: 'Place', width: 55, renderer: PlaceCell},
      {key: 'weight', label: 'Squat 1', width: 70, lift: 'squat', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 2', width: 70, lift: 'squat', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 3', width: 70, lift: 'squat', attemptNumber: '3', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 1`, width: 70, lift: 'bench', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 2`, width: 70, lift: 'bench', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 3`, width: 70, lift: 'bench', attemptNumber: '3', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 1', width: 70, lift: 'dead', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 2', width: 70, lift: 'dead', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 3', width: 70, lift: 'dead', attemptNumber: '3', renderer: AttemptCell},
      {key: 'total', label: 'Total', width: 80, renderer: TotalCell},
      {key: 'total', label: 'Wilks Adjusted Total', width: 150, renderer: BodyWeightAdjustedTotalCell},
      {key: 'total', label: 'Age Adjusted Total', width: 145, renderer: AgeAdjustedTotalCell},
      {key: 'total', label: 'Wilks & Age Adjusted Total', width: 195, renderer: BodyWeightAndAgeAdjustedTotalCell}
    ];
  };

  getCellLines = (index) => {
    return 1;
  };

  render() {
    const { data, shouldDisplayRow } = this.props;

    const filteredData = _.filter(data, (lifter) => {
      return (
        !lifter ||
        lifter.row === "title" ||
        lifter.row === "header" ||
        shouldDisplayRow(lifter)
      );
    });

    const columns = this.getAllColumns();

    return (
      <Table
        data={filteredData}
        numberOfFixedLeftColumns={2}
        columns={columns}
        getCellLines={this.getCellLines}
        meet={this.props.meet}
        scrollToAlignment="center"
        media={this.props.media}
        padBottom
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    data: getResultsTableData(state, props),
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(TeamResultsTable));
